export const RAI_MODAL_CONSTANT = {
  MODAL_TITLE: "Content not ready for publishing",
  MODAL_DESCRIPTION_SUCCESS: "By choosing to proceed, you must agree to a formal legal approval process before this content goes live.",
  MODAL_DESCRIPTION_FAILURE: "Your content has not passed our Responsible AI check. By choosing to proceed you accept all responsibility.",
  CLOSE: "Close",
  AGREE_AND_CONTINUE: "Agree & Continue",
  DOWNLOAD_SUCCESS_TITLE: "When downloading AIDA files you must:",
  DOWNLOAD_SUCCESS_DESCRIPTION: ["Agree to get formal legal approval before any content goes live.", "Preserve the current file name."],
  ERROR_TYPE: "RAI Check",
  DISCLAIMER:
    "Caution: Product or packaging in generated images may need significant retouching and may show incorrect or incomplete branding, claims, or information.",
  IMAGE: "Image",
};
